import React from 'react';

function ProcessClaim() {
  return <div>ProcessClaim</div>;
}

export default ProcessClaim;
